import React, { useRef, useState, useEffect } from "react";
import { Dialog } from "antd-mobile-v5";
import { LinkOutline, ExclamationCircleFill, EditSOutline, InformationCircleOutline } from "antd-mobile-icons";
import "./subjectBind.scss";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ApiCore } from "../../api";
import { DialogShowHandler } from "antd-mobile-v5/es/components/dialog";
import { Modal } from "antd-mobile";

// #region 解绑记录显示
type BindRecordProps = {
  subjectCode: string
  targetName: string
}

const BindRecord: React.FC<BindRecordProps> = ({ subjectCode, targetName })=> {
  const [label, setLabel] = useState('')
  const [title, setTitle] = useState('')

  const fetchBindInfo = async (subjectCode: string) => {
    type Before = {
      code: string
      isDr: boolean
    }
    type DataType = {
      state: 0 | 1
      unbound: null | Before
      bound: null | Before
    }
    // 未绑且不是君实项目时
    const { code, data } = await api.getUnbindRecord<DataType>(subjectCode)
    if (code == '0') {
      const { state, bound, unbound } = data
      // 已绑定时显示原绑定记录
      if (state === 1) {
        // bound
        if (bound) {
          if (bound.code) {
            setTitle(`原绑定${bound.code}`)
          }
          setLabel(bound.isDr ? '医生解绑' : `${targetName}解绑`)
        }
      } else {
        // 未绑时显示新绑定记录
        if (unbound) {
          if (unbound.code) {
            setTitle(`绑定至${unbound.code}`)
          }
          setLabel(unbound.isDr ? '医生解绑' : `${targetName}解绑`)
        }
      }
    }
  }

  const showBindRecord = ()=> {
    if (title.length === 0) {
      return
    }
    Modal.alert('绑定记录', <p style={{margin: 0, fontSize: 12}}>{title}</p>, [
      {
        text: '关闭',
        onPress: ()=>{},
      }
    ])
  }

  useEffect(()=> {
    fetchBindInfo(subjectCode);
  }, [subjectCode])

  if (label === '') {
    return null
  }

  return (
    <span onClick={showBindRecord} style={{color: '#39f', background: '#e3ebfd', fontSize: 12, padding: '3px 5px', marginLeft: '5px', borderRadius: 4}}>
      {label}
      {
        title.length > 0 && (
          <InformationCircleOutline style={{marginLeft: 5}}/>
        )
      }
    </span>
  )
}
//#endregion

interface SubjectBindProps extends RouteComponentProps<{ id: string }> {
  initData?: ()=> void;
  refresh: (visitId: string) => void;
  isShowBind: Boolean;
  resumeVisitId: string;
  subjectName: string,
  mobile: string,
  editModel: number
}

const api = new ApiCore();

const SubjectBind = (props: SubjectBindProps) => {
  const { id: subjectCode } = props.match.params;
  
  const { resumeVisitId, refresh, initData } = props;
  const [info, setInfo] = useState<{ bindState: number, reportName: string }>({ bindState: -1, reportName:''});
  const handler = useRef<DialogShowHandler>();
  //受试者名称
  const targetName = sessionStorage.getItem('targetName') || '受试者';
  useEffect(() => {
    if (!subjectCode) return;
    subjectBindState(subjectCode);
  }, [subjectCode]);

  const subjectBindState = async (subjectCode: string) => {
    try {
     api.getSubjectBindState(subjectCode).then(res=>{
        setInfo(res.data ?? { bindState: -1 });
     })

    } catch (error) {
      return Promise.reject(error);
    }
  };
  const dialogContentCop = () => (
    <>
      <ExclamationCircleFill className="bind-dialog--icon" />
      您正在解绑患者，解绑之后需要重新绑定患者！
    </>
  );

  const openUnbindModal = () => {
    handler.current = Dialog.show({
      content: dialogContentCop(),
      bodyClassName: "bind-dialog",
      actions: [
        [
          {
            key: "cancel",
            text: "取消",
            onClick: () => handler.current?.close?.(),
          },
          {
            key: "delete",
            text: "确认",
            bold: true,
            danger: true,
            onClick: handleUnbind,
          },
        ],
      ],
    });
  };

  // 解绑
  const handleUnbind = async () => {
    try {
      const { code }: any = await api.subjectUnbind(subjectCode);
      handler.current?.close?.();
      refresh(resumeVisitId);
      initData?.()
      
      if (code === 0) {
        await subjectBindState(subjectCode);
      }
      return Promise.resolve();
    } catch (error) {
      return Promise.reject();
    }
  };

  const handleClickBindState = () => {
    if (info.bindState === 1) {
      openUnbindModal();
    }
    if (info.bindState === 0) {
      // 跳转到扫码页面
      props.history.push(`/subjectBindType/${subjectCode}`)
    }
  };

  const handleEdit = ()=>{
    props.history.push(`/editSubject/${subjectCode}`)
  }

   // 手机号脱敏
   const encryptPhoneNumber = (phoneNumber: string) =>{
    if(phoneNumber) {
      return phoneNumber.replace(/^(1\d{2})(\d{4})(\d{4})$/g, '$1****$3')
    }
    return '暂无'
  }
  
  //角色code为ReadOnly 表单只读
  let  token: any = sessionStorage.getItem('token');
  const projectRoleCode = sessionStorage.getItem('projectRoleCode');

  token = JSON.parse(token);
  return (subjectCode && info.bindState > -1) ? (
    <div className="bind-container" data-state={info.bindState} >
      { props.editModel === 1 && 
        <>
          <div className="bind-user"><span className="bind-user-title"></span>{props.subjectName ? props.subjectName : '---'} | {encryptPhoneNumber(props.mobile)}</div>
          <div className="bind-user-operate">
          &nbsp;  {info.bindState == 0 && ['EDC_CRC', 'DCT_CRC'].includes(token.roleCode) && projectRoleCode !== "ReadOnly" && <span><span onClick={handleEdit}><EditSOutline/>修改</span>&nbsp;</span> }
            
            {
              ['EDC_CRC', 'DCT_CRC'].includes(token.roleCode) && projectRoleCode !== "ReadOnly" && 
                <span hidden={!props.isShowBind} onClick={handleClickBindState} >
                  <LinkOutline className="bind-icon" />
                {info.bindState === 1 &&  "解绑"}
                {info.bindState === 0 &&  "绑定"}
              
              </span>
            }
          
          </div>
        </>
      }
      {  props.editModel !== 1 && 
        <>
        <span className="bind-user">{info.bindState === 1?<><span className="bind-user-title">{targetName}：</span>{props.subjectName ? props.subjectName : '---'}</>:''}</span>
          &nbsp; {
            <span onClick={handleClickBindState}>
              <LinkOutline className="bind-icon" />
              {info.bindState === 1 &&  "解绑"}
              {info.bindState === 0 &&  "绑定"}
            </span>
          }
          <BindRecord targetName={targetName} subjectCode={subjectCode}/>
        </>
      }
    </div>
  ) : null
};

export default withRouter(SubjectBind);
